import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import { useStore } from "vuex";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const { getHeader, getFooter } = pdfHeaderFooter();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, reportData, startDate, endDate, qrcode) => {
        const doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName, qrcode),
            content: getContent(reportData, startDate, endDate),
            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Item Supplier Report'
            }
        }

        pdfMake.createPdf(doc).open();
    }

    const getContent = (reportData, startDate, endDate) => {
        const content = [
            {
                text: 'Item Supplier Report',
                fontSize: 14,
                bold: true,
                alignment: 'center',
                decoration: 'underline',
                margin: [0, 0, 0, 4]
            },
            {
                text: `Date: ${startDate} - ${endDate}`,
                margin: [0, 0, 0, 8]
            }
        ]

        const grandTotal = {
            subtotal_amount: 0,
            vat_amount: 0,
            net_invoice_amount: 0,
            paid_amount: 0,
            due: 0
        }

        reportData.forEach(invoice => {
            content.push(getInvoiceItem(invoice))
            const due = parseFloat(invoice.total_amount) - parseFloat(invoice.paid_amount) - parseFloat(invoice.adjustment_amount)
            grandTotal.subtotal_amount    += parseFloat(invoice.subtotal_amount)
            grandTotal.vat_amount         += parseFloat(invoice.vat_amount)
            grandTotal.net_invoice_amount += parseFloat(invoice.total_amount)
            grandTotal.paid_amount        += parseFloat(invoice.paid_amount)
            grandTotal.due                += due
        })

        content.push(getGrandTotalTable(grandTotal))

        return content
    }

    const getGrandTotalTable = (grandTotal) => {
        return {
            margin: [0, 8, 0, 0],
            table: {
                widths: ['*', '*', '*', '*', '*'],
                body: [
                    [
                        { text: 'Grand Total', bold: true, colSpan: 5, alignment: 'center', fillColor: '#f3f2f7' },
                        {}, {}, {}, {}
                    ],
                    [
                        { text: [{ text: 'Total Bill Amount: ', bold: true }, commaFormat(grandTotal.subtotal_amount)] },
                        { text: [{ text: 'Total VAT Amount: ', bold: true }, commaFormat(grandTotal.vat_amount)] },
                        { text: [{ text: 'Net Bill Amount: ', bold: true }, commaFormat(grandTotal.net_invoice_amount)] },
                        { text: [{ text: 'Total Paid: ', bold: true }, commaFormat(grandTotal.paid_amount)] },
                        { text: [{ text: 'Total Due: ', bold: true }, commaFormat(grandTotal.due.toFixed(2))] }
                    ]
                ]
            },
            layout: {
                fillColor: (rowIndex) => rowIndex === 0 ? '#f3f2f7' : '',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5
            },
            fontSize: 8
        }
    }

    const getInvoiceItem = (invoice) => {
        const due = (parseFloat(invoice.total_amount) - parseFloat(invoice.paid_amount) - parseFloat(invoice.adjustment_amount)).toFixed(2)

        return {
            stack: [
                {
                    columns: [
                        { text: [{ text: 'Bill No: ', bold: true }, invoice.bill_number] },
                        { text: [{ text: 'Date: ', bold: true }, invoice.date] },
                        { text: [{ text: 'Supplier: ', bold: true }, invoice.contact_profile_name] }
                    ],
                    margin: [0, 6, 0, 4]
                },
                {
                    fontSize: 8,
                    table: {
                        widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: getItemTableBody(invoice.general)
                    },
                    layout: {
                        fillColor: (rowIndex) => rowIndex === 0 ? '#f3f2f7' : null,
                        hLineWidth: () => 0.5,
                        vLineWidth: () => 0.5
                    }
                },
                {
                    stack: [
                        {
                            columns: [
                                { text: [{ text: 'Total Bill Amount: ', bold: true }, commaFormat(invoice.subtotal_amount)] },
                                { text: [{ text: 'Total VAT Amount: ', bold: true }, commaFormat(invoice.vat_amount)] },
                                { text: [{ text: 'Net Bill Amount: ', bold: true }, commaFormat(invoice.total_amount)] },
                              ]
                        },
                        {
                            columns: [
                                { text: [{ text: 'Total Paid: ', bold: true }, commaFormat(invoice.paid_amount)] },
                                { text: [{ text: 'Total Due: ', bold: true }, due] },
                                { text: [{ text: '', bold: true }, ''] }
                            ],
                            margin: [0, 2, 0, 0]
                        }
                    ],
                    fontSize: 8,
                    margin: [0, 4, 0, 2]
                },
                { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 780, y2: 0, lineWidth: 0.5, lineColor: '#cccccc' }], margin: [0, 4, 0, 0] }
            ]
        }
    }

    const getItemTableBody = (items) => {
        const header = [
            { text: 'Item Name', bold: true },
            { text: 'Unit', bold: true },
            { text: 'Qty', bold: true, alignment: 'right' },
            { text: 'Price', bold: true, alignment: 'right' },
            { text: 'Amount', bold: true, alignment: 'right' },
            { text: 'Discount', bold: true, alignment: 'right' },
            { text: 'VAT Amount', bold: true, alignment: 'right' },
            { text: 'Total Amount', bold: true, alignment: 'right' }
        ]

        const rows = items.map(item => [
            { text: item.product_name },
            { text: item.unit_name },
            { text: commaFormat(item.quantity), alignment: 'right' },
            { text: commaFormat(item.rate), alignment: 'right' },
            { text: commaFormat(item.amount), alignment: 'right' },
            { text: commaFormat(item.discount_amount), alignment: 'right' },
            { text: commaFormat(item.vat_amount), alignment: 'right' },
            { text: commaFormat(item.total_amount), alignment: 'right' }
        ])

        return [header, ...rows]
    }

    return { exportToPDF }
}

export default pdfPrinter;
